// removed by extract-text-webpack-plugin
module.exports = {"card":"Asin__card__3Z-Ef","select":"Asin__select__HCeqU","input":"Asin__input__2-EfR","button":"Asin__button__pm7-w","selectDiv":"Asin__selectDiv__1CsvO","asinSelectDiv":"Asin__asinSelectDiv__3Fqo2","inputDiv":"Asin__inputDiv__1xejE","btnDiv":"Asin__btnDiv__2tjuI","icon":"Asin__icon__rFcir","iconAmazon":"Asin__iconAmazon__33Kmh"};


//////////////////
// WEBPACK FOOTER
// ./src/Asin/Asin.css
// module id = 42
// module chunks = 0